export const BookingFee = ({ ticket, currency }) => (
  <div>
    + {currency}
    {ticket.get('booking_fee_fixed')} fee
  </div>
);
